import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import {graphql, Link} from 'gatsby';
import htmr from 'htmr';
import SEO from '../Templates/SEO';
// import '../styles/style.main.min.css';
import * as styles from './Styles/facultypage.module.scss';
import '../Templates/Styles/facultypage.scoped.scss';
import {Card, Container} from 'react-bootstrap';
import Header from './Shared/Header';
import Footer from './Shared/Footer';
import '../styles/cookieconsent.min.css';
import * as utils from './Shared/Utils';
import AssetsService from '../Application/Shared/AssetsService';
import UtmService from './Services/UtmService';
import Countdown from 'react-countdown';
import {GatsbyImage, getImage} from 'gatsby-plugin-image';
import SubscribeBanner from './Shared/SubscribeBanner';
import SocialShare from './Shared/SocialShare';
import {
  data as pageDataJSON,
} from '../data/facultyPageData.json';

const FacultyPage = ({data}) => {
  const canonicalPages = utils.getCanonicalPages(
      data.brandWebsiteFacultypage.url,
  );
  const pageData = {
    ...data,
    ...pageDataJSON,
    canonicalPages,
  };
  const facultyPageData=pageData.brandWebsiteFacultypage;
  const headerContent = pageData.brandWebsiteHeader;
  const footerContent = pageData.brandWebsiteFooter;
  const courseList=pageData.allBrandWebsiteCoursepages.nodes;
  const locale=facultyPageData.locale;
  const imageData = pageData.allS3Object;
  const wideAssetsService = new AssetsService('WEBSITE_WIDE');
  const sqaureAssetsService = new AssetsService('WEBSITE_SQUARE');
  const cataloguePageData=pageData.brandWebsiteCoursecataloguepage;
  const localizedCataloguePageLink=
  utils.getLocalizedPageLink(facultyPageData.locale, cataloguePageData.url);
  const [listMode, switchViewMode] = useState(false);
  const [activeCourse, setActiveCourse] = useState('');

  const handleScroll = () => {
    const images = document.getElementsByTagName('img');
    Array.from(images).forEach((img) => {
      if (img.dataset.src && img.src.indexOf(img.dataset.src) <= -1) {
        img.src = img.dataset.src;
      }
    });
  };

  useEffect(() => {
    const utmService=new UtmService();
    utmService.init();
    const trackingObj = {
      pageKind: 'WebsiteFacultyPage',
      locale: facultyPageData.locale,
      courseSlug: '',
      facultySlug: facultyPageData.facultyslug,
    };
    utils.trackPageView(trackingObj);
    utils.setChatBotVisibility(false);
    utils.initializePrices();
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  /**
 *
 *
 * @export
 * @param {*} locale
 * @param {*} link
 * @return {*}
 */
  function getLocalizedGeneralSignupLink(locale) {
    const defaultsToEn=['en', 'en-gb', 'en-us'];
    const languagePath = defaultsToEn.includes(locale) ? '' : locale + '/';
    const generalSignupURL = `/${languagePath}signup/`;
    return generalSignupURL;
  };

  const canonicalList=facultyPageData.seo.canonicalurls;
  const canonicalUrls=[];
  if (canonicalList) {
    for (let index=0; index<canonicalList.length; index++) {
      canonicalUrls.push({
        'href': canonicalList[index].href,
        'rel': 'canonical',
      });
    }
  }

  const languageCanonicals = pageData.canonicalPages;
  const homePageLink = utils.getLocalizedPageLink(facultyPageData.locale, '/');
  return (
    <>
      <SEO
        locale={facultyPageData.locale}
        title={facultyPageData.seo.title}
        description={facultyPageData.seo.description}
        image={facultyPageData.seo.image.href}
        canonicalUrls={canonicalUrls}
        languageCanonicals={languageCanonicals}
        siteMetadata={pageData.site.siteMetadata}
      />
      <Helmet>
        <script>
          window.dataLayer=window.dataLayer||[];
        </script>
      </Helmet>
      <Helmet>
        <script async src="/js/cookieconsent-scripts.min.js"></script>
      </Helmet>
      <Header headerContent={headerContent} locale={facultyPageData.locale} />
      <div className={styles.facultyPageContainer}>
        <main className="facultypage">
          <div className={`${styles.catalogueContainer}`}>
            <div className={`${styles.catalogueMenu} faculty-container`}>
              <div className={`${styles.pathIndicator}
                 library-brand-icon-new`}>
                <Link to={homePageLink}>Home</Link>
                <span>
                  <i className="icon-new-right-arrow"></i>
                </span>
                <Link to={localizedCataloguePageLink}>Course Catalogue</Link>
              </div>
            </div>
            <div className='faculty-container'>
              <h2 className={styles.subHeading}>Explore</h2>
              <h1 className={styles.pageHeading}>{facultyPageData.heading}</h1>
              <div className={styles.categoryInfo}>
                {htmr(facultyPageData.facultydescription)}
              </div>
            </div>
            <div className={`${styles.catalogueList} faculty-container`}>
              <div className={styles.catalogueSection}>
                <div className={styles.sectionHeader}
                  data-faculty={facultyPageData.facultyslug}>
                  <div className={`library-brand-icon ${styles.headerIcon}`}>
                    {/* <i
                      className={`icon-${facultyPageData.facultyslug}`}>
                    </i> */}
                  </div>
                  <div className={styles.sectionHeadingName}>
                    {facultyPageData.title}
                  </div>
                  <hr />
                </div>
                <div className={styles.sectionBody}
                  data-faculty={facultyPageData.facultyslug}>
                  {courseList.map((course, index) => {
                    const courseURL = utils.
                        getLocalizedPageLink(locale, course.url);
                    const customAltText =
                    course?.modular_blocks?.
                        [0]?.herosection?.bannerimagealttext;
                    const courseId = course.courseslug;
                    const signupURL = utils
                        .getLocalizedSignupLink(locale, courseId);
                    const wideImage = wideAssetsService
                        .fetchAssetURL(courseId);
                    const squareImage = sqaureAssetsService
                        .fetchAssetURL(courseId);
                    const currentCourseImageNode =
                        imageData.nodes.filter((
                            node) => (
                          node.Key.includes(courseId)
                        ),
                        )[0];
                    const courseImage = currentCourseImageNode &&
                        currentCourseImageNode.localFile &&
                        getImage(
                            currentCourseImageNode.localFile.
                                childImageSharp.gatsbyImageData);
                    return (
                      <Card key={index} className={styles.card}>
                        <div
                          className={`${styles.cardList}`}>
                          <Link to={course.url}
                            className={styles.cardImg}>
                            <GatsbyImage
                              image={courseImage}
                              alt={customAltText ?
                              customAltText : courseId }
                            />
                          </Link>
                          <div className={styles.cardContent}>
                            <div className={styles.cardInfo}>
                              <div className={styles.shareSection}>
                                <Link to={course.url}
                                  className={styles.courseName}>
                                  {course.coursemenuname
                                      ?.replace(/(.{40})..+/, '$1…')}
                                </Link>
                                <SocialShare
                                  key={index}
                                  courseUrl={course.url}
                                  courseName={course.coursemenuname}
                                  activeCourse={activeCourse}
                                  setActiveCourse={setActiveCourse}/>
                              </div>
                              <div className={styles.ratingContent}>
                                <div className={styles.enrollCount}>
                                  {course.graduates?.toLocaleString()} Students
                                </div>

                                {/* <div className={styles.rating +
                                  ' library-brand-icon'}>
                                  <p>{course.rating/10}</p>
                                  <img src="/images/transparent.svg"
                                    data-src="/images/home/new/star.svg"
                                    alt="star" />
                                </div> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </Card>
                    );
                  } )}
                </div>
              </div>
              {/* <div className={styles.categoryBottomInfo}>
                <h4>Explore certified diploma</h4>
                <h3>Business Courses</h3>
                <p>
                  Whether you want to advance your career
                   in the business world or develop
                  new skills to improve your own business, Upskillist’s
                    range of university-certified business courses
                    will equip you
                    with the qualifications you need to succeed.
                From Bookkeeping, Project Management, Leadership,
                  Entrepreneurship, Excel, and much more, Upskillist’s
                   cost-effective learning
                 solution allows you to earn the certifications you need to
                   enhance your resume and improve your career.
                </p>
                <p>Starting free for four weeks, you can get unlimited
                  access to our portfolio of expert-curated online business
                    courses before deciding to pursue
                     your chosen subjects in-depth.</p>
              </div> */}
              <div className={styles.categoryBottomInfo}>
                {htmr(facultyPageData.facultydescriptionbottom)}
              </div>
            </div>
            {/* {facultyPageData.facultyfooter.map((section) => {
              return htmr(section.content);
            })} */}
            <div className='faculty-container'>
              <div className="course-benefits" id="benefits">
                <div className="course-benefits-header">
                  <h2>Course Benefits</h2></div>
                <div className="row">
                  <div className="feature">
                    <div className="box">
                      <img src="/images/home/new/app-section/compare.svg"
                        data-src="/images/home/new/app-section/compare.svg"
                        width="23" height="18" alt="compare" />
                    </div>
                    <div className="wording">
                      <div className="feature-heading">
                      Flexible online classes
                      </div>
                      <div className="feature-info">
                    Pick your schedule or on-demand.</div>
                    </div>
                  </div>
                  <div className="feature">
                    <div className="box">
                      <img src="/images/home/new/app-section/pause.svg"
                        // eslint-disable-next-line max-len
                        data-src="/images/home/new/app-section/pause.svg"
                        width="17" height="22" alt="pause"/>
                    </div>
                    <div className="wording">
                      <div className="feature-heading">Pause course</div>
                      <div className="feature-info">
                    Take a break any time.</div>
                    </div>
                  </div>
                  <div className="feature">
                    <div className="box">
                      <img src="/images/home/new/app-section/support.svg"
                        data-src="/images/home/new/app-section/support.svg"
                        width="19" height="21" alt="support"/>
                    </div>
                    <div className="wording">
                      <div className="feature-heading">
                    Education support
                      </div>
                      <div className="feature-info">
                    Always get your answers.</div>
                    </div>
                  </div>
                  <div className="feature">
                    <div className="box">
                      <img src="/images/home/new/app-section/download.svg"
                        data-src="/images/home/new/app-section/download.svg"
                        width="12" height="16" alt="download" />
                    </div>
                    <div className="wording">
                      <div className="feature-heading">
                    Course materials
                      </div>
                      <div className="feature-info">
                    Extra resources, extra help.</div>
                    </div>
                  </div>
                  <div className="feature">
                    <div className="box">
                      <img
                        src="/images/home/new/app-section/badge.svg"
                        // eslint-disable-next-line max-len
                        data-src="/images/home/new/app-section/badge.svg"
                        width="48" height="52" alt="double-up-arrow" />
                    </div>
                    <div className="wording">
                      <div className="feature-heading">
                    Accredited Courses</div>
                      <div className="feature-info">
                    Globally recognised.
                      </div>
                    </div>
                  </div>
                  <div className="feature">
                    <div className="box">
                      <img
                        src="/images/home/new/app-section/document.svg"
                        // eslint-disable-next-line max-len
                        data-src="/images/home/new/app-section/document.svg"
                        width="15" height="20" alt="document" />
                    </div>
                    <div className="wording">
                      <div className="feature-heading">
                      Mutiple Faculties</div>
                      <div className="feature-info">
                    80+ courses.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
        {/* <Container>
          <div className={styles.stickyButton}>
            <div className={styles.trailDay}>
              <Link to={getLocalizedGeneralSignupLink(locale)}
                className={styles.bannerPinkBtn}>
              4 Weeks Free Unlimited Access
              </Link>
            </div>
            <p className={styles.stickyInfo}>
            Sign up now and get <strong>unlimited access</strong> to <strong>
              ALL of our courses</strong>. Get 8 classes for free and
              <strong> access them for Life</strong>.
            </p>
          </div>
        </Container> */}
        <div className={styles.subscriberBannerContainer}>
          <SubscribeBanner />
        </div>
      </div>
      <Footer
        footerData={footerContent}
        siteMetadata={pageData.site.siteMetadata}
      />
    </>
  );
  TimerRenderer.propTypes = {
    formatted: PropTypes.object,
    completed: PropTypes.bool,
  };
};
FacultyPage.defaultProps = {
  data: {},
};

FacultyPage.propTypes = {
  data: PropTypes.object,
};
export default FacultyPage;
export const pageQuery = graphql`
  query FacultyPageID($id: String, $locale: String,
    $custom_s3KeyArray: [String]) {
    brandWebsiteFacultypage(id: { eq: $id }) {
      url
      locale
      title
      pageslug
      heading
      facultyslug
      facultydescription
      facultyfooter {        
        content
      }
      seo{
        title
        description
        image {
          title
          href
        }
        canonicalurls {
          title
          href
        }
      }      
      facultydescriptionbottom
    }
    allBrandWebsiteCoursepages(sort: {order: ASC, fields: [menuorder]},filter: {
      locale: {eq: $locale},
      reference: {
      elemMatch: {id: {eq: $id}}}}) {
        nodes {
          title
          url  
          courseslug
          rating
          graduates
          coursecarddescription
          coursemenuname
          seo {
            description
          }
          modular_blocks {
            herosection {
              bannerimagealttext
            }
          }
        }
      }
      site {
        siteMetadata {
          title
          siteUrl
          description
          social {
            twitter
            facebook
            instagram
            linkedIn
          }
        }
      }
      allS3Object(filter: {Key: {in: $custom_s3KeyArray}}) {
        nodes {
          Key
          localFile {
            childImageSharp {
              gatsbyImageData
            }
          }
        }
      }
    }
`;
